import type { ReactNode } from "react";
import "./PositionsList.scss";
import type { Position } from "@/pages/human-resources/time-management/business/Position.ts";
import classNames from "classnames";
import PositionCell from "@/pages/human-resources/time-management/components/schedule-palette/positions/PositionCell.tsx";
import { useTranslation } from "react-i18next";
import useKeywordsFilter from "@/shared/custom-hook/useKeywordsFilter.ts";
import HelpMessage from "@/pages/human-resources/time-management/components/daily-tags/HelpMessage.tsx";

interface Properties {
  positions: Position[];
  horizontal: boolean;
  searchInput: string;
}

export default function PositionsList(props: Properties): ReactNode {
  const { t } = useTranslation("humanResources", {
    keyPrefix: "timeManagement",
  });

  const searchFilter = useKeywordsFilter(
    props.searchInput,
    props.positions,
    (p) => p.label,
  );

  return (
    <div
      className={classNames("positions-list", props.horizontal && "horizontal")}
    >
      <HelpMessage text={t("help.pickPosition")} />
      <div className="scrollable-list">
        {props.positions.filter(searchFilter).map((p) => (
          <PositionCell key={p.id} position={p} />
        ))}
      </div>
    </div>
  );
}
